import React from 'react';
import '../template-file-css/document-file-template.css';


export const RNFI_ConsentToTreatment = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='RNFI_ConsentToTreatment' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'><center><h3>Consent to Treatment</h3></center></p>
                <p className='w-750'>I hereby give my permission for <input type="text" id='txtProviderPractice' name='txtProviderPractice' className='add-only w-250 custom-add-only' /> (the Practice) to give me medical treatment.</p>
                <p className='w-750'>I understand that conversations with the therapist will almost always be confidential with the exception
                    of a life threatening emergency. I further understand that therapist, by law, must report actual or
                    suspected child or elder abuse to the appropriate authorities. In addition, the therapist has a legal
                    responsibility to protect anyone I/he/she/we may threaten with violence, harmful or dangerous actions
                    (including those to myself) and may break confidentially of communication if such a situation arises. I
                    understand that the therapist will make reasonable efforts to resolve these situations before breaking
                    confidentiality.</p>
                <p className='w-750'>I understand that I might be required to visit a licensed psychiatrist for an initial assessment and I agree
                    with my therapist scheduling and appointment for me. I also give consent to RNF to submit an appeal
                    on my behalf, in case the authorization for services is denied by my Care Management Organization
                    (CMO). It is the client's responsibility to keep their Medicaid current and if it lapses during treatment
                    fees may be assessed on a sliding fee scale.</p>
                <p className='w-750'>I allow the Practice to file for insurance benefits to pay for the care I receive. <br />
                    I understand that:</p>
                <p className='w-750'>  <ul>
                    <li>
                        The Practice will have to send my medical record information to my insurance company.
                    </li>
                    <li>
                        Payment must be rendered at the time of service.
                    </li>
                    <li>
                        I must not act with inappropriate or disruptive behavior with office staff and/ or provider. I
                        understand that it will not be tolerated and may result in my termination from the clinic.
                    </li>
                    <li>
                        Any No-Show/ Late Cancellation (Under 24 hours notice) I will be charged $100.00 for
                        appointment time. I understand this fee is not covered by my insurance and I may be dismissed
                        from Ravens Nest Foundation if this behavior continues.
                    </li>
                    <li>
                        I must pay for the cost of these services if my insurance does not pay or I do not have insurance.
                    </li>
                    <li>
                        I will pay my co-pay and/or co-insurance fee at the time of service.
                    </li>
                </ul>
                </p>
                <p className='w-750'>
                    I understand my rights:
                </p>
                <p className='w-750'>
                    <ul>
                        <li>
                            I have the right to refuse any procedure or treatment.
                        </li>
                        <li>
                            I understand if I see the provider for multiple conditions, that I will need separate appointments to
                            address each condition.
                        </li>
                        <li>
                            I have the right to discuss all medical treatments with my provider.
                        </li>
                    </ul>
                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className="small w-375"> Signature of Patient or Legal Guardian</td>
                        <td className='small w-375'>Patient Name:</td>
                    </tr>
                </table>
            </div>
        </form>

    )
}











